<template>
  <div id="select" v-if="isShow">
    <Multiselect
        v-model="fields.value"
        @change="onChange"
        mode="tags"
        :placeholder="fields.label"
        noResultsText="Результатов не найдено"
        :searchable="true"
        :close-on-select="true"
        :options="fields.items"
        :trackBy="'name'"
    >
      <template v-slot:tag="{ option, handleTagRemove, disabled }">
        <div class="multiselect-tag element" :class="{ 'is-disabled': disabled }">
          <div class="user-name">{{ option.name }}</div>
          <span v-if="!disabled" class="multiselect-tag-remove" @mousedown.prevent="handleTagRemove(option, $event)">
            <span class="multiselect-tag-remove-icon"></span>
          </span>
        </div>
      </template>
      <template v-slot:option="{ option }">
        <div class="option-user">
          <div class="user-name">{{ option.name }}</div>
        </div>
      </template>
    </Multiselect>

    <div v-if="v$.value.$invalid">
      <span :class="{'is-invalid': v$.value.$invalid && v$.value.$dirty}"></span>
      <div class="invalid-feedback" v-for="error of v$.value.$silentErrors" :key="error.$uid">
        {{ error.$message }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted } from 'vue'
import Multiselect from '@/plugins/multiselect'
import { useVuelidate } from '@vuelidate/core'

const props = defineProps({
  payload: {
    type: Object,
    required: true,
  },
})

const emit = defineEmits(['onChangeVal'])

// ----- reactive state -----
const show = ref(false)
const fields = reactive({
  value: null,
  items: [],
  label: null,
})

const $externalResults = reactive({})

// ----- Vuelidate -----
const rules = computed(() => ({
  value: {
    // required validation можно добавить
  },
}))
const v$ = useVuelidate(rules, fields, { $externalResults })

// ----- show/hide -----
function markShow() { show.value = true }
function markUnshow() { show.value = false }
function isShow() { return show.value }

// ----- обновление полей -----
async function updateFields(payload) {
  fields.value = payload.value
  fields.items = payload.items ?? []
  fields.label = payload.label
}

// ----- динамическое отслеживание items -----
watch(() => props.payload.items, (newItems) => {
  fields.items = newItems ?? []
}, { immediate: true })

watch(() => props.payload.value, (newValue) => {
  fields.value = newValue
}, { immediate: true })

watch(() => props.payload.label, (newLabel) => {
  fields.label = newLabel
}, { immediate: true })

// ----- handlers -----
function onChange(value) {
  validate(() => {
    pushParent(value)
  })
}

function pushParent(value) {
  emit('onChangeVal', {
    sub_type_id: value,
  })
}

// ----- validation -----
async function validate(fn = () => {}) {
  v$.value.$clearExternalResults()
  await v$.value.$validate()
  await fn()
}

// ----- mounted -----
onMounted(async () => {
  markUnshow()
  await updateFields(props.payload)
  markShow()
})
</script>
